namespace('arctic.views.groupLanding');

compass.require('compass.hotel.StayRecapWidget');
compass.require('compass.hotel.RoomRequestsWidget');
compass.require('compass.hotel.RoomSharesWidget');
compass.require('compass.hotel.PoliciesWidget');

compass.require('compass.demographic.PersonalInfoWidget');
compass.require('compass.demographic.PasswordWidget');
compass.require('compass.demographic.PaymentWidget');
compass.require('compass.demographic.FrequentGuestNumberWidget');
compass.require('compass.util.validate');


arctic.views.groupLanding.groupMemberInfo = function(viewport,options) {
	// starts measuring the time it takes for the view to load
	compass.startLoad('groupMemberInfoView');
	var me = this;

	var _viewport = viewport;
	var d = jQuery.dom;
	var $j = jQuery;

	// handle the merge with the new defineView
	var _settings = options;

	var _jsonData;

	var _frequentGuestNumberWidget, _personalInfoWidget, _passwordWidget, _paymentWidget, _roomRequestsWidget, _roomSharesWidget, _stayRecapWidget;
	var _groupMememberFormInvalid = false;
	var _form;

	var _labels = {
		'useGroupPayment': 'Your room is secured by your group manager.'
	};

	var _str2date = function (src) {
		src = src.split("-");
		return new Date(parseInt(src[0], 10), parseInt(src[1], 10),
				parseInt(src[2], 10), 0, 0, 0, 0);
	};

	var _drawTermsOfService = function(){
		if (_settings.meetingInfo.privacyPolicyLink.length === 0 ) return d.span({className: 'termsOfServiceText'}, '.');
		return [
				d.span({className: 'termsOfServiceText'}, ' and our '),
				d.a({className: 'termsOfServiceLink', 'href': _settings.meetingInfo.privacyPolicyLink, 'target': '_blank'}, 'terms of service.')
		];
	};

	
	var _render = function(d) {
		_form = d.form({ className: 'forms' },
			d.div({ className : 'personalInfoHeader'},
				d.div({ className : 'personalInfoTitle'}, 'Contact Details')
			),
			d.div({className : 'personalInfoInstruction'},
				"Please enter the name of the primary guest staying in this room."
			),
			d.div({ className : 'personalInfo' },
				d.div({ className : 'personalInfoMain' }),
				d.div({ className : 'passwordsMain' }),
				d.div({ className : 'paymentHeader' },
					d.div({ className : 'paymentTitle'}, 'Payment Guarantee')
				),
				d.div({ className : 'creditCardTitle demographicTitle' }, 'We need a credit card to hold your room. Don' + "'" + 't worry, we won' + "'" + 't charge it today. Review the hotel policies for additional information.'),
				d.div({ className : 'creditCardMain' }),
				d.div({ className : 'endPaymentInfo' }),
				d.div({ className : 'roomRequestsHeader'},
					d.div({ className : 'roomRequestsTitle'}, 'Room Requests (optional)')
				),
				d.div({ className : 'roomRequestsMain' }),
				d.div({ className : 'roomSharesHeader' },
					d.div({className : 'roomSharesTitle'},'Room Shares',
						d.span({className : 'optionalSection'}, ' (optional)')
					)
				),
				d.div({ className : 'roomSharesMain' }),
			
			d.div({ className : 'frequentGuestNumberHolder'}),
				d.div({className : 'policiesAgreeDiv'},
					d.input({className : 'policiesCheckbox',
						name: 'policiesCheckbox',
						'data-parsley-required': 'true',
						type: 'checkbox',
						value:'true'}),
					d.div({className :'policiesTextDiv'}, 'By placing your booking with us, you agree to the '),
					d.a({ className:'policiesLink'}, 'hotel policies'),
					d.div({className :'clear'}),
					_drawTermsOfService()
				),
				d.input({ className : 'finishButton button',
								type : 'submit',
								value : 'Finish'})
			)
		);

		_form.on('submit', function (evt) {
			evt.preventDefault();
			evt.stopPropagation();
			_submitPersonalInfoForm();
		});

		_viewport.append(
			_form,
			d.div({ className : 'stayRecapMain' })
		);
	};

	var _addValidation = function() {
		_form.parsley({
			aria: true,
			errorClass: 'invalid',
			errorsContainer: function (elem) {
				elem = elem.$element;
				var $container = elem.next();

				if ($container.hasClass('reqHint')) {
					return $container;
				}

				var $container = d.div({ className: 'reqHint' });
				$container.append(d.div({ className: 'triangle' }));

				elem.after($container);
				
				elem.one('focus', function (evt) {
					$container.css({ "left": (elem.outerWidth(true)-$container.outerWidth(true))/2 + elem.position().left });
				});
				
				return $container;
			},
			errorsWrapper: '<div class=\'text\'></div>',
			errorTemplate: '<span></span>'
		});

		_form.parsley().on('form:error', function() {
 			_groupMememberFormInvalid = true;
 			return;
 		});

		_form.parsley().on('field:validate', function(elem) {
			return !$(elem).is(":visible") || $(elem).hasClass('placeholder');
		});

		_form.parsley().on('field:success', function(elem) {
			if (_groupMememberFormInvalid) { 
				if (_form.find('.invalid').length < 1) {
					_groupMememberFormInvalid = false;
					var button = _form.find('.finishButton');
					button.removeClass('disabled').attr('tabindex', '0');
				}
			}
		});
	};

	var _setupWidgets = function(viewdata) {
		_personalInfoWidget = new compass.demographic.PersonalInfoWidget(_viewport.find('.personalInfoMain'), {
			WUID : 'personalInfoWidget_individualPersonalInfo',
			drawAddress : false
		});

		_passwordWidget = new compass.demographic.PasswordWidget(_viewport.find('.passwordsMain'), {
			WUID : 'passwordWidget_individualPersonalInfo'
		});
		
		if (viewdata.rules.rules.creditCard) {
			_paymentWidget = new compass.demographic.PaymentWidget(_viewport.find('.creditCardMain'), {
				WUID : 'PaymentWidget_individualPersonalInfo',
				addressWidget : {countries : _settings.countriesAndStates.countries, states : _settings.countriesAndStates.states, countries_with_states : _settings.countriesAndStates.countries_with_states},
				creditCardTypes : viewdata.paymentOptions.pay_methods,
				displayCVC: viewdata.paymentOptions.store_cvc,
				minExpiration: _str2date(_settings.depart),
				maskCCNumber : _.contains(viewdata.extraRequiredFields, 'maskCreditCard')
			});
		} else {
			_viewport.find('.creditCardTitle').text(_labels.useGroupPayment);
		}

		_roomRequestsWidget = new compass.hotel.RoomRequestsWidget(_viewport.find('.roomRequestsMain'), {
			WUID : 'roomRequestsWidget_individualPersonalInfo',
			collapsable : true,
			roomRequestOptions : viewdata.requests.requests,
			accessibilityOptions : viewdata.requests.accessibilityOptions,
			showExtraNotes : viewdata.requests.showExtraNotes,
			showADAOptions : viewdata.requests.showADAOptions,
			notes : viewdata.requests.notes
		});

		if ( viewdata.roomSharesInfo.numberOfShares > 0 ) {
			_roomSharesWidget = new compass.hotel.RoomSharesWidget(_viewport.find('.roomSharesMain'), {
				WUID : 'roomSharesWidget_individualPersonalInfo',
				collapsable : true,
				numberOfShares : viewdata.roomSharesInfo.numberOfShares,
				firstDate: viewdata.arrival,
				lastDate: viewdata.departure,
			});
		} else {
			_viewport.find('.roomSharesHeader').hide();
		}

		_frequentGuestNumberWidget = new compass.demographic.FrequentGuestNumberWidget(_form.find('.frequentGuestNumberHolder'), {
			WUID : 'frequentGuestNumber_groupPersonalInfo',
			frequentGuestNumber : null
		});

		_stayRecapWidget = new compass.hotel.StayRecapWidget(_viewport.find('.stayRecapMain'), {
					WUID : 'stayRecapWidget_individualPersonalInfo',
					meetingInfo : _settings.meetingInfo,
					recapArray : [{ "stayRecap": viewdata.stayRecap }]
				});

		_stayRecapWidget.bind('StayRecapWidget.showPolicies', function () {
			compass.GA.trackEvent('Hotel Policies', 'View Policies', 'Group Info - Receipt');
			_showPoliciesPopup(viewdata);
		});

		_viewport.find(".policiesLink").activate(function(){
			compass.GA.trackEvent('Hotel Policies', 'View Policies', 'Group Info - Agree Link');
			_showPoliciesPopup(viewdata);

		});

		_viewport.find(".stayRecapMain").append(d.div({className : 'stayRecapShadow'}));

		_viewport.find('.policiesCheckbox').change(function() {
			if ($(this).is(':checked')) {
				$('.alertCloseButton').activate();
			}
		});
	};

	var _showPoliciesPopup = function(viewdata) {
		jQuery.ajax({
			data: { blocked_room_id: viewdata.blockedRoomId },
			dataType:'json',
			traditional: true,
			url:'/policies',
			success : function(data) {

				var policiesDiv = d.div({className:'policiesContainer'});
				_policiesWidget = new compass.hotel.PoliciesWidget(policiesDiv,
					{
						WUID : 'policiesWidget_individualPersonalInfo',
						policies: data
					});

				_policiesDialog = d.dialog({
					classes: 'personalInfo policiesDialog',
					contents: policiesDiv,
					centerOnView: true
				});
			}
		});
	};

	var _setupControls = function(viewData) {

	};

	var _validationRes = [];
	var _submitPersonalInfoForm = function() {
		var button = _viewport.find(".finishButton");
		if(button.hasClass('disabled')) {
			return;
		}
		button.addClass('disabled');

		var formData = {};

		formData['policiesCheckbox'] = $j('.policiesCheckbox').prop('checked');
		if(formData['policiesCheckbox'] === false){
			_policiesAgreeDialog = d.alert("Please agree to your hotel's policies before continuing.");
		}

		_form.parsley().validate();

		if(!_form.parsley().isValid()){
			_groupMememberFormInvalid = true;
 			return;
 		}

		var widgetArray = [_personalInfoWidget, _passwordWidget,_paymentWidget,_roomRequestsWidget,_frequentGuestNumberWidget];

		jQuery.map(widgetArray, function(widget){
			if (typeof widget !== 'undefined') {
				formData[widget.getWidgetName()] = widget.grabValues();
			}
		});

		if(_roomSharesWidget){
			formData[_roomSharesWidget.getWidgetName()] = _roomSharesWidget.grabValues();
		}else{
			formData["RoomSharesWidget"] = [];
		}

		var submitData = {
			meeting_code : compass.matchDict.meetingCode,
			arrive : _settings.arrive,
			depart : _settings.depart,
			blocked_room_id : _settings.blocked_room_id,
			data : JSON.stringify(formData)
		};
		jQuery.ajax({
			url : '/actGroupMemberInfo',
			method : 'POST',
			data : submitData,
			error : function() {
				button.prop("disabled", false);
				button.css({cursor : 'inherit'});
			},
			success : function(data) {
				$j('body').css({cursor : 'inherit'});
				/* put logic to move the page along if success is returned in data packet */
				if ( data.success) {
					jQuery.ajax({
					url : '/sendConfirmation',
						success : function(data) {

						}
					});				
					_viewport.trigger(CompassEvents.Navigate, 'frontDesk');
					$j('body').trigger(CompassEvents.Login, data.loginInfo);
					$j('body').css({cursor : 'inherit'});
				} else {
					if (data.policiesCheckboxChecked === false) {
						d.alert("Please agree to the hotel policies before continuing.");
					} else {
						alert ('Problem creating record.');
					}
				}
			}
		});
	};

	this.run = function(renderComplete) {
		var data = {
			arrive : _settings.arrive,
			depart : _settings.depart,
			blocked_room_id : _settings.blocked_room_id
		};
		compass.loading.start();
		jQuery.ajax({
			url : '/groupMemberInfo',
			data : data,
			success : function(data) {
				compass.loading.stop();
				_jsonData = data;
                _settings.countriesAndStates = data.countriesAndStates;
				_render(jQuery.dom);
				// move this into a renderer for testing.
				_setupWidgets(data);
				// add parsley validation to form
				_addValidation();
				// draws the widgets and passes any rendering data into them.
				_setupControls();
				// sets up controls on the widgets. setups controls on the view itself.
				// stops measuring the time it takes the view to load
				compass.stopLoad('groupMemberInfoView');
				renderComplete();
			}
		});
	};
};
